<table
  mat-table
  [dataSource]="dataSource"
  [style.paddingLeft]="paddingLeft"
  [style.paddingRight]="paddingRight"
  [style.paddingTop]="paddingTop"
  [style.paddingBottom]="paddingBottom"
>
  @for (columnDef of input.columns; track columnDef) {
    <ng-container
      [matColumnDef]="columnDef.name | parse: context | async"
      [sticky]="columnDef.sticky"
    >
      @for (cellDef of columnDef.cells; track cellDef) {
        @switch (cellDef.type) {
          @case ('header') {
            <th mat-header-cell *matHeaderCellDef>
              <ng-container
                *ngTemplateOutlet="
                  expressionOrWidget;
                  context: { widget: cellDef.widget, context: context }
                "
              ></ng-container>
            </th>
          }
          @case ('data') {
            <td mat-cell *matCellDef="let row">
              @if (
                mergeContexts(
                  context,
                  wrapContext(row, input?.rowDataAlias || 'row')
                );
                as mergedContext
              ) {
                <ng-container
                  *ngTemplateOutlet="
                    expressionOrWidget;
                    context: {
                      widget:
                        cellDef.widget
                        | parse
                          : mergedContext
                          : { maxParseDepth: 1, keyWhitelist: ['id'] }
                        | async,
                      context: mergedContext,
                    }
                  "
                ></ng-container>
              }
            </td>
          }
          @case ('footer') {
            <td mat-footer-cell *matFooterCellDef>
              <ng-container
                [dynamicWidget]="cellDef.widget"
                [context]="context"
              ></ng-container>
            </td>
          }
        }
      }
    </ng-container>
  }

  <!-- The following code throws an error if used as the only source of row definitions, at least one header and data row
has to be defined in a hardcoded manner (see below)-->
  <tr
    mat-header-row
    *matHeaderRowDef="
      input.mainHeaderRow.activeColumns | parse: context | async;
      sticky: input.mainHeaderRow.sticky
    "
  ></tr>
  @for (rowDef of input.rows; track rowDef) {
    @switch (rowDef.type) {
      @case ('header') {
        <tr
          mat-header-row
          *matHeaderRowDef="
            rowDef.activeColumns | parse: context | async;
            sticky: rowDef.sticky
          "
        ></tr>
      }
      @case ('data') {
        <tr
          mat-row
          *matRowDef="
            let row;
            columns: rowDef.activeColumns | parse: context | async
          "
        ></tr>
      }
      @case ('footer') {
        <tr
          mat-footer-row
          *matHeaderRowDef="
            rowDef.activeColumns | parse: context | async;
            sticky: rowDef.sticky
          "
        ></tr>
      }
    }
  }
  <tr
    mat-row
    *matRowDef="
      let row;
      columns: input.mainDataRow.activeColumns | parse: context | async
    "
    (click)="onRowClick($event, row)"
  ></tr>
</table>

<ng-template #expressionOrWidget let-widget="widget" let-context="context">
  @if (isPrimitive(widget)) {
    {{ widget }}
  } @else {
    @if (isExpression(widget)) {
      {{ widget | parse: context | async }}
    } @else {
      <ng-container [dynamicWidget]="widget" [context]="context" />
    }
  }
</ng-template>
